import { render, staticRenderFns } from "./RenovationProject.vue?vue&type=template&id=1a244e18&"
import script from "./RenovationProject.vue?vue&type=script&lang=js&"
export * from "./RenovationProject.vue?vue&type=script&lang=js&"
import style0 from "./RenovationProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports